import { Helmet } from 'react-helmet';
import type { WebPageDataFragment } from '../../../../api/fragments/WebPageData';
import { useRuntimeConfig } from '../../../../runtimeConfig';

type MetaDataProps = {
    webpage: WebPageDataFragment;
};

const WebPageMetaData = ({ webpage }: MetaDataProps) => {
    const title = webpage.metaTitle ?? webpage.pageTitle?.defaultValue;
    const description = webpage.metaDescription;
    const {
        router: { hostname: domain },
    } = useRuntimeConfig();

    return (
        <Helmet>
            {description && <meta content={description} name="description" />}
            <meta content="INDEX, FOLLOW, NOARCHIVE" name="robots" />

            {/* Facebook Meta Tags */}
            <meta content={title} property="og:title" />
            <meta content={domain} property="og:site_name" />
            {description && <meta content={description} property="og:description" />}

            {/* Twitter Meta Tags */}
            <meta content={title} property="twitter:title" />
            <meta content={domain} property="twitter:domain" />
            {description && <meta content={description} property="twitter:description" />}
        </Helmet>
    );
};

export default WebPageMetaData;
